export default __webpack_public_path__ + "static/media/bewilder.ea10daa8.png";